<template>
  <div id="edit-area">
    <Modal v-model="modal.visible" :title="modal.title" footer-hide>
      <Form  ref="editAreaForm"  :model="editArea" :rules="editAreaRule" v-loading="loading">
        <FormItem  label="省份" prop="provinceCode" v-show="userType <= 3" >
          <Select v-model="editArea.provinceCode" style="width: 420px" @on-change="changeProvince">
            <Option v-for="item in areaController.provinceList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem  label="城市" prop="cityCode" v-if="userType <= 4">
          <Select v-model="editArea.cityCode" style="width: 420px" @on-change="changeCity">
            <Option v-for="item in areaController.cityList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem  label="区域" prop="areaCode" v-if="userType <= 5">
          <Select v-model="editArea.areaCode" style="width: 420px" @on-change="changeArea">
            <Option v-for="item in areaController.areaList" :value="item.code" v-bind:key="item.code" @click.native="changeAreaName(item.name)">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem  label="街道"  prop="streetCode" v-if="userType > 3 && userType <= 5">
          <Select v-model="editArea.streetCode" style="width: 420px" @on-change="changeStreet">
            <Option v-for="item in areaController.streetList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem  label="机构"  prop="institutionId">
             <el-select v-model.trim="editArea.institutionId" placeholder="请选择机构"
                        clearable filterable
                        size="small"
                        transfer="true"
                        :popper-append-to-body="false"
                        style="width: 420px;">
               <el-option v-for="item in areaController.institutionList"
                 :key="item.id"
                 :label="item.name + (item.subordinate && item.subordinate.length > 0 ? '-' + item.subordinate : '')"
                 :value="item.id"
                  @click.native="handleRemoteMethodChange(item)"
                 style="width:420px;z-index: 9999;"
               />
             </el-select>

          </FormItem>
          <FormItem style="text-align: center;">
            <Button type="primary" @click="handleSubmit">确定</Button>
            <Button style="margin-left: 8px" @click="modal.visible=false">取消</Button>
        </FormItem>
      </Form>
      <!-- IForm -->
    </Modal>
  </div>
</template>
<script>
import {getStreetByArea, getAreaByCity, getCityByProvince} from "@/services/manage/tenant";
import {_findByAreaCode, _findByStreetCode, _findByRoleId} from "@/services/manage/institutions";
export default {
  inject: ['reload'],
  name: "EditArea",
  data() {
    return {
      areaController:{
        provinceList:[],
        cityList:[],
        areaList:[],
        streetList:[],
        institutionList:[]
      },
      // 加载状态
      loading: false,
      userType : null,
      // 模态框属性
      modal: {
        title: "",
        visible: false
      },
      // 表单数据对象
      editArea: {
        provinceCode: "",
        cityCode : "",
        areaCode: "",
        areaName: "",
        streetCode: "",
        institutionId: "",
        institution: ""
      },
      // 表单验证规则
      editAreaRule: {
        provinceCode: [
          {
            required: true,
            message: "请选择省份",
            trigger: "blur",
            type:'number'
          }
        ],
        cityCode: [
          {
            required: true,
            message: "请选择城市",
            trigger: "blur",
            type:'number'
          }
        ],
        areaCode: [
          {
            required: true,
            message: "请选择区",
            trigger: "blur",
            type:'number'
          }
        ],
        streetCode: [
          {
            required: true,
            message: "请选择街道",
            trigger: "blur",
            type:'number'
          }
        ],
        institutionId: [
          {
            required: true,
            message: "请选择机构",
            trigger: "blur",
            type:'number'
          }
        ]
      }
    };
  },
  methods: {
    showModal() {
      this.modal = {
        title: "地区切换",
        visible: true
      };

      if(this.$userSession.getCode() && this.$userSession.getCode().provinceCode){
        this.changeProvince(this.$userSession.getCode().provinceCode, true)
      }

      if(this.$userSession.getCode() && this.$userSession.getCode().cityCode){
        this.changeCity(this.$userSession.getCode().cityCode, true)
      }

      if(this.$userSession.getCode() && this.$userSession.getCode().areaCode){
        this.changeArea(this.$userSession.getCode().areaCode, true)
      }

      if(this.$userSession.getCode() && this.$userSession.getCode().streetCode && this.userType > 3){
        this.changeStreet(this.$userSession.getCode().streetCode, true)
      }

      if(this.$userSession.getRole() && this.$userSession.getRole().roleId && this.userType >= 6){
        this.findByRoleId(this.$userSession.getRole().roleId, true);
      }

      this.editArea.provinceCode = (this.$userSession.getCode() && this.$userSession.getCode().provinceCode ? this.$userSession.getCode().provinceCode : ""),
      this.editArea.cityCode = (this.$userSession.getCode() && this.$userSession.getCode().cityCode ? this.$userSession.getCode().cityCode : ""),
      this.editArea.areaCode = (this.$userSession.getCode() && this.$userSession.getCode().areaCode ? this.$userSession.getCode().areaCode : ""),
      this.editArea.areaName = (this.$userSession.getCode() && this.$userSession.getCode().areaName ? this.$userSession.getCode().areaName : ""),
      this.editArea.streetCode = (this.$userSession.getCode() && this.$userSession.getCode().streetCode ? this.$userSession.getCode().streetCode : ""),
      this.editArea.institutionId = (this.$userSession.getInstitutionId() != null ? this.$userSession.getInstitutionId() : "");

      this.loadAreaData();
    },
    handleSubmit() {

      if(this.userType <= 2) {
        this.$refs['editAreaForm'].validateField('provinceCode');
      }
      if(this.userType <= 3) {
        this.$refs['editAreaForm'].validateField('cityCode');
      }
      if(this.userType > 3 && this.userType <= 4) {
        this.$refs['editAreaForm'].validateField('areaCode');
      }
      if(this.userType > 3 && this.userType <= 5){
        this.$refs['editAreaForm'].validateField('streetCode');
      }
      this.$refs['editAreaForm'].validateField('institutionId');

      if(this.userType <= 2 && (!this.editArea.provinceCode || !this.editArea.cityCode || !this.editArea.areaCode || !this.editArea.institutionId)){
        return;
      }else if(this.userType <= 3 && (!this.editArea.cityCode || !this.editArea.areaCode || !this.editArea.institutionId)){
        return;
      }else if(this.userType > 3 && this.userType <= 4 && (!this.editArea.areaCode || !this.editArea.streetCode || !this.editArea.institutionId)){
        return;
      }else if(this.userType > 4 && this.userType <= 5 && (!this.editArea.streetCode || !this.editArea.institutionId)){
        return;
      }else if(this.userType > 5 && !this.editArea.institutionId){
        return;
      }
      this.switchArea();
    },
    switchArea(){
      if(this.userType <= 3){
        if (this.editArea.institutionId){
          this.modal.visible = false;

          this.$userSession.getUserInfo().institution = {
            id : this.editArea.institution.id,
            name : this.editArea.institution.name,
            subordinate : this.editArea.institution.subordinate,
            doctor : this.editArea.institution.doctor,
            analysisTemplateId : this.editArea.institution.analysisTemplateId,
            targetTemplateId : this.editArea.institution.targetTemplateId,
            filing : this.editArea.institution.filing,
            organId : this.editArea.institution.organId,
          }

          this.$userSession.getUserInfo().code = {
            streetName : "",
            areaCode : this.editArea.areaCode,
            areaName : this.editArea.areaName,
            provinceCode : this.editArea.provinceCode ? this.editArea.provinceCode : this.$userSession.getCode().provinceCode,
            cityCode : this.editArea.cityCode ? this.editArea.cityCode : this.$userSession.getCode().cityCode
          }

          this.$store.commit("USER_INFO", this.$userSession.getUserInfo());
          this.$emit('onFinish',this.editArea.institution.name);

          this.$message.success('切换成功!');
          this.$Loading.finish();
          this.reload()
        }else {

          this.$userSession.getUserInfo().institution = {
            id : "",
            name : "",
            subordinate : "",
            analysisTemplateId : "",
            targetTemplateId : "",
            doctor : "",
            filing : "",
            organId : "",
          }
          this.$store.commit("USER_INFO", this.$userSession.getUserInfo());

          this.modal.visible = false;
          this.reload()
        }
      }else{
        this.$Loading.start();
        this.loading = true;

        if (this.editArea.institutionId && this.areaController.institutionList && this.areaController.institutionList.length > 1 && this.areaController.streetList.length > 0) {
          for (let i = 0; i < this.areaController.streetList.length; i++) {
            let item = this.areaController.streetList[i];
            if (item.code != this.editArea.streetCode) {
              continue
            }
            this.$userSession.getCode().streetCode = item.code;
            this.$userSession.getCode().streetName = item.name;

            for (let j = 0; j < this.areaController.institutionList.length; j++) {
              let item1 = this.areaController.institutionList[j];
              if (item1.id != this.editArea.institutionId) {
                continue
              }
              this.$userSession.getUserInfo().institution = {
                id: item1.id,
                name: item1.name,
                subordinate: item1.subordinate,
                doctor: item1.doctor,
                analysisTemplateId: item1.analysisTemplateId,
                targetTemplateId: item1.targetTemplateId,
                filing: item1.filing,
                organId: item1.organId,
              }
              this.$store.commit("USER_INFO", this.$userSession.getUserInfo());
              this.$emit('onFinish', item.name);
            }
          }
          this.$message.success('切换成功!');
          this.$Loading.finish();
          this.reload()
          this.modal.visible = false;
        }else if (this.editArea.institutionId && this.areaController.institutionList && this.areaController.institutionList.length > 1){
          for (let j = 0; j < this.areaController.institutionList.length; j++) {
            let item1 = this.areaController.institutionList[j];
            if (item1.id != this.editArea.institutionId) {
              continue
            }
            this.$userSession.getUserInfo().institution = {
              id : item1.id,
              name : item1.name,
              subordinate : item1.subordinate,
              doctor : item1.doctor,
              analysisTemplateId : item1.analysisTemplateId,
              targetTemplateId : item1.targetTemplateId,
              filing : item1.filing,
              organId : item1.organId,
            }
            this.$store.commit("USER_INFO", this.$userSession.getUserInfo());
          }
          this.$message.success('切换成功!');
          this.$Loading.finish();
          this.reload()
          this.modal.visible = false;
        }else if (this.editArea.streetCode){
          for (let i = 0; i < this.areaController.streetList.length; i++) {
            let item = this.areaController.streetList[i];
            if (item.code == this.editArea.streetCode) {
              this.$userSession.getCode().streetCode = item.code;
              this.$userSession.getCode().streetName = item.name;
              if(this.areaController.institutionList && this.areaController.institutionList.length == 1){
                this.$userSession.getUserInfo().institution = {
                  id : this.areaController.institutionList[0].id,
                  name : this.areaController.institutionList[0].name,
                  subordinate : this.areaController.institutionList[0].subordinate,
                  doctor : this.areaController.institutionList[0].doctor,
                  analysisTemplateId : this.areaController.institutionList[0].analysisTemplateId,
                  targetTemplateId : this.areaController.institutionList[0].targetTemplateId,
                  filing : this.areaController.institutionList[0].filing,
                  organId : this.areaController.institutionList[0].organId,
                }
              }else{
                this.clearInstitution();
              }
              this.$store.commit("USER_INFO", this.$userSession.getUserInfo());
              this.$emit('onFinish',item.name);
              break;
            }
          }
          this.$message.success('切换成功!');
          this.$Loading.finish();
          this.reload()
          this.modal.visible = false;
        }else {
          this.clearInstitution();
          this.$store.commit("USER_INFO", this.$userSession.getUserInfo());

          this.$message.success('切换成功!');
          this.reload()
          this.modal.visible = false;
        }
        this.loading = false;
      }
    },
    clearInstitution(){
      this.$userSession.institution = {
        id : "",
        name : "",
        subordinate : "",
        doctor : "",
        analysisTemplateId : "",
        filing : "",
        organId : "",
      }
    },
    //省份选择市
    changeProvince(code, reset){
      if(!code){
        return;
      }

      //根据省份编号查询市
      getCityByProvince({province : code}).then(res=>{
        this.editArea.provinceCode = code;
        this.$userSession.getCode().provinceCode = code;
        if (res.errcode === 1 && res.data) {
          this.areaController.cityList = res.data;
        }else if (res.errcode != 1){
          this.reload()
        }else{
          this.areaController.cityList = [];
        }

        if(!reset){
          this.editArea.cityCode = "";

          this.editArea.areaCode = "";
          this.areaController.areaList = [];

          this.editArea.streetCode = "";
          this.areaController.streetList = [];

          this.editArea.institutionId = "";
          this.areaController.institutionList =[];
        }
      })
    },
    //市选择区
    changeCity(code, reset){
      if(!code){
        return;
      }
      //根据市编号查询区
      getAreaByCity({cityCode: code}).then(res=>{
        this.editArea.cityCode = code;
        this.$userSession.getCode().cityCode = code;
        if (res.errcode === 1 && res.data){
          this.areaController.areaList = res.data;
        }else if (res.errcode != 1){
          this.reload()
        }else{
          this.areaController.areaList =[];
        }

        if(!reset){
          this.editArea.areaCode = "";
          this.editArea.areaName = "";

          this.editArea.streetCode = "";
          this.areaController.streetList =[];

          this.editArea.institutionId = "";
          this.areaController.institutionList =[];
        }
      })
    },
    //区选择机构
    changeArea(code, reset){
      if(!code){
        return;
      }

      if(this.userType <= 3){
        //根据区编号查询机构
        _findByAreaCode({areaCode : code}).then(res=>{
          this.editArea.areaCode = code;
          if (res.errcode === 1 && res.data){
            this.areaController.institutionList = res.data;
            if(this.areaController.institutionList && this.areaController.institutionList.length == 1){
              this.editArea.institutionId = this.areaController.institutionList[0].id;
            }
          }else if (res.errcode != 1){
            this.reload()
          }else{
            this.editArea.institutionId = "";
            this.areaController.institutionList =[]
          }

          if(!reset){
            this.editArea.institutionId = "";
          }
        })
      }else{
        //根据区编号查询街道
        getStreetByArea({areaCode : code}).then(res=>{
          this.$userSession.getCode().areaCode = code;
          if (res.errcode === 1 && res.data){
            this.areaController.streetList = res.data;
          }else if (res.errcode != 1){
            this.reload()
          }else{
            this.areaController.streetList = [];
          }

          if(!reset){
            this.editArea.institutionId = "";
            this.areaController.institutionList =[];
          }
        })
      }
    },
    //街道选择机构
    changeStreet(code, reset){

      if(!code){
        return;
      }

      //根据街道编号查询机构
      _findByStreetCode({streetCode:code}).then(res=>{
        if (res.errcode === 1 && res.data){
          this.$userSession.getCode().streetCode = code;
          this.areaController.institutionList = res.data;
          if(this.areaController.institutionList && this.areaController.institutionList.length == 1){
            this.editArea.institutionId = this.areaController.institutionList[0].id;
          }
        }else if (res.errcode != 1){
          this.reload()
        }else{
          this.editArea.institutionId = "";
          this.areaController.institutionList =[]
        }
      })
    },
    //角色选择机构
    findByRoleId(roleId, reset){

        if(!roleId){
            return;
        }

        //根据街道编号查询机构
        _findByRoleId({roleId:roleId}).then(res=>{
            if(res.data){
                this.areaController.institutionList = res.data;
                if(this.areaController.institutionList && this.areaController.institutionList.length == 1){
                    this.editArea.institutionId = this.areaController.institutionList[0].id;
                }

                let institutions = [];
                for (let j = 0; j < this.areaController.institutionList.length; j++) {
                  let item1 = this.areaController.institutionList[j];
                    institutions.push({
                      id: item1.id,
                      name: item1.name,
                      subordinate: item1.subordinate,
                      doctor: item1.doctor,
                      analysisTemplateId: item1.analysisTemplateId,
                      targetTemplateId: item1.targetTemplateId,
                      filing: item1.filing,
                      organId: item1.organId,
                    });
                }
                this.$userSession.getUserInfo().institutions = institutions;
                this.$store.commit("USER_INFO", this.$userSession.getUserInfo());
            }else{
                this.editArea.institutionId = "";
                this.areaController.institutionList =[]
            }
        })
    },
    changeAreaName(areaName){
      this.editArea.areaName = areaName;
    },
    // 下拉框-选值后处理
    handleRemoteMethodChange(item) {
      this.editArea.institutionId = item.id;
      this.editArea.institution = item;
    },
    reset(){
      this.loadAreaData();
    },
    loadAreaData(){
      if(this.$userSession.getUserInfo()){
        let userType = this.userType;
        switch(userType){
          case 1:
          case 2:
            this.areaController.provinceList=this.$userSession.getTenants();
            this.areaController.cityList=[];
            this.areaController.areaList=[];
            this.areaController.institutionList=[];
            break;
          case 3:
            this.areaController.provinceList=this.$userSession.getTenants();
            if(this.areaController.provinceList && this.areaController.provinceList.length == 1){
              this.changeProvince(this.areaController.provinceList[0].code, true);
              this.editArea.provinceCode = this.areaController.provinceList[0].code;
            }
            this.areaController.cityList=[];
            this.areaController.areaList=[];
            this.areaController.institutionList=[];
            break;
          case 4:
            this.areaController.provinceList=[];
            this.areaController.cityList=this.$userSession.getTenants();
            if(!this.editArea.cityCode && this.areaController.cityList && this.areaController.cityList.length >= 1){
              this.changeCity(this.areaController.cityList[0].code, true);
              this.editArea.cityCode = this.areaController.cityList[0].code;
            }
            this.areaController.areaList=[];
            this.areaController.streetList=[];
            this.areaController.institutionList=[];
            break;
          case 5:
            this.areaController.provinceList=[];
            this.areaController.cityList=[];
            this.areaController.areaList=this.$userSession.getTenants();
            if(this.areaController.areaList && this.areaController.areaList.length == 1){
              this.changeArea(this.areaController.areaList[0].code, true);
              this.editArea.areaCode = this.areaController.areaList[0].code;
            }
            this.areaController.streetList=[];
            this.areaController.institutionList=[];
            break;
          case 6:
          case 7:
            this.areaController.institutionList=this.$userSession.getInstitutions();
        }
      }
    }
  },
  mounted() {
    // this.loadAreaData();

    this.userType = this.$userSession.getUserType();
  }
};
</script>
